import styled from "styled-components";
import { Container } from "../../globalStyles";
import { Link } from "react-router-dom";

export const Nav = styled.nav`
  background: var(--bg-base);
  height: 4.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.2rem;
  position: sticky;
  top: 0;
  z-index: 999;
  transition: border-color 0.2s ease;
  border-bottom: 1px solid
    ${({ scrolled }) =>
      scrolled ? "var(--border-subtle)" : "transparent"};
`;

export const NavbarContainer = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4.5rem;
`;

export const NavLogo = styled(Link)`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.3s ease;

  &:hover {
    opacity: 0.85;
  }
`;

export const NavLogoImg = styled.img`
  height: 2.1rem;
  width: auto;
  display: block;

  @media screen and (max-width: 480px) {
    height: 1.8rem;
  }
`;

export const HamburgerIcon = styled.div`
  display: none;
  color: var(--text-primary);

  @media screen and (max-width: 960px) {
    display: block;
    font-size: 1.5rem;
    cursor: pointer;
    z-index: 1000;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-left: auto;

  @media screen and (max-width: 960px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    padding-top: 2rem;
    background: var(--bg-base);
    transition: all 0.5s ease;
    position: absolute;
    top: 0;
    left: ${({ click }) => (click ? 0 : "-100%")};
    opacity: ${({ click }) => (click ? 1 : 0)};
    z-index: 998;
  }
`;

export const NavItem = styled.li`
  height: 4.5rem;
  display: flex;
  align-items: center;
  position: relative;

  @media screen and (max-width: 960px) {
    width: 100%;
    height: 64px;
    justify-content: center;
  }
`;

export const NavLinks = styled(Link)`
  color: var(--text-secondary);
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1.1rem;
  height: 100%;
  font-weight: 500;
  font-size: 1rem;
  transition: color 0.18s ease;

  &:hover {
    color: var(--text-primary);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: -4px;
    border-radius: 4px;
  }

  @media screen and (max-width: 960px) {
    padding: 1.2rem;
    width: 100%;
    text-align: center;
    justify-content: center;
    font-size: 1.2rem;
  }
`;

export const NavExternalLink = styled.a`
  color: var(--brand-dark);
  background: var(--primary-400);
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0.45rem 1rem;
  border: 2px solid var(--text-primary);
  border-radius: var(--radius-sm);
  font-weight: 700;
  font-size: 0.9375rem;
  margin-left: 0.8rem;
  box-shadow: 3px 3px 0 var(--text-primary);
  transition: transform 0.12s ease, box-shadow 0.12s ease;

  &:hover {
    transform: translate(-1px, -1px);
    box-shadow: 4px 4px 0 var(--text-primary);
  }

  &:active {
    transform: translate(1px, 1px);
    box-shadow: 2px 2px 0 var(--text-primary);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 3px;
  }

  @media screen and (max-width: 960px) {
    margin-left: 0;
    margin-top: 1rem;
    padding: 0.8rem 2rem;
    font-size: 1.05rem;
  }
`;

export const LanguageContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1rem;

  @media screen and (max-width: 960px) {
    margin-left: 0;
    margin-top: 1.5rem;
  }
`;

export const LanguageButton = styled.button`
  background: transparent;
  color: var(--text-secondary);
  border: 1px solid var(--border-strong);
  padding: 0.35rem 0.75rem;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: border-color 0.18s ease, color 0.18s ease;

  &:hover {
    border-color: var(--text-primary);
    color: var(--text-primary);
  }

  &:focus-visible {
    outline: 2px solid var(--accent);
    outline-offset: 3px;
  }
`;
